import { ReactElement } from "react"

import CreateDeviceForm from "../../../../components/devices/ttr/createDeviceForm"
import PublishDeviceProvider from "../../../../components/devices/ttr/providers/publishDeviceProvider"

/** Webpage for allowing users to publish a device */
const PublishDevice = (): ReactElement => (
    <PublishDeviceProvider>
        <CreateDeviceForm />
    </PublishDeviceProvider>
)

export default PublishDevice
